<!-- Default Button -->
<ng-container *ngIf="mode === 'button'">
    <ng-container [ngSwitch]="variant" >
    
        <button
            *ngSwitchCase="'default'"
            mat-button
            [color]="color"
            (click)="onClick()"
        >
            <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
        </button>
    
        <button
            *ngSwitchCase="'stroke'"
            mat-stroked-button
            [color]="color"
            (click)="onClick()"
        >
            <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
        </button>

    </ng-container>
</ng-container>

<!-- Dropdown -->
<ng-container *ngIf="mode === 'dropdown' && dropdownOptions">

    <ng-container [ngSwitch]="variant" >
    
        <button
            *ngSwitchCase="'default'"
            mat-button
            [color]="color"
            [matMenuTriggerFor]="menu"
        >
            <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
        </button>
    
        <button
            *ngSwitchCase="'stroke'"
            mat-stroked-button
            [color]="color"
            (click)="onClick()"
            [matMenuTriggerFor]="menu"
        >
            <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
        </button>

    </ng-container>

    <mat-menu #menu="matMenu">
        <button mat-menu-item *ngFor="let item of dropdownOptions.data" (click)="onSelect(item.value)" [ngClass]="{'active': item.isActive}">
            {{item.label}}
        </button>
    </mat-menu>
</ng-container>


<ng-template #buttonContent>
    <div class="flex-container">
        <img *ngIf="icon" class="image-icon" [src]="icon" alt="">
        <ng-content></ng-content>
        <img *ngIf="mode === 'dropdown'" class="image-icon" src="/assets/images/icons/down-arrow-icon.svg" alt="">
    </div>
</ng-template>